/**
 * L'adresse « canonique » de la page : celle que Google doit retenir.
 *
 * `index.html` portait une balise canonique FIXE vers /shop. Toutes les pages
 * en héritaient — chaque fiche produit, chaque rayon, chaque actualité disait
 * à Google « je suis une copie de /shop ». Search Console (12/10/2026) écartait
 * donc les ~1 050 fiches du plan du site : « Autre page avec balise canonique
 * correcte », « Page en double sans URL canonique sélectionnée ».
 *
 * Chaque page déclare désormais SA propre adresse.
 */
import { useEffect } from 'react';

const ORIGINE = 'https://foliesboutik.be';

/**
 * Chemin canonique du catalogue. `?produit=` est retiré de la barre d'adresse
 * dès l'ouverture de la fiche (elle vit dans l'état de la page) : il faut donc
 * le reprendre de l'état, pas de l'URL, sinon la fiche redeviendrait « /shop ».
 */
export function cheminCatalogue(produit: string | null | undefined, rayon: string | null | undefined): string {
  if (produit) return `/shop?produit=${encodeURIComponent(produit)}`;
  if (rayon) return `/shop?rayon=${encodeURIComponent(rayon)}`;
  return '/shop';
}

export function useCanonical(chemin: string | null) {
  useEffect(() => {
    if (!chemin) return;
    let lien = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    const cree = !lien;
    if (!lien) {
      lien = document.createElement('link');
      lien.rel = 'canonical';
      document.head.appendChild(lien);
    }
    lien.href = ORIGINE + chemin;
    return () => {
      if (cree) lien?.remove();
    };
  }, [chemin]);
}
